<template>
<div class="form-part">
  <div class="row">
    <div class="col-2 label-right mt-1">
      <label>File name</label>
    </div>
    <div class="col-4">
      <b-form-input v-model="fields.simple_file_name" class="file_name_input"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <NameResolver fields-prefix="simple" />
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <ToggleAllButton fields-prefix="simple" />
    </div>
  </div>

  <div class="row">
    <div class="col-2">
      <b-form-checkbox v-model="fields.simple_date_obs_sel" :disabled="toggleStatus" class="mt-1">Observation date</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-input-group>
        <b-form-input v-model="fields.simple_date_obs_min" placeholder="yyyy-MM-dd"></b-form-input>
        <b-input-group-append>
          <VueCtkDateTimePicker v-model="fields.simple_date_obs_min" format="YYYY-MM-DD" :no-label="true" :only-date="true" :no-value-to-custom-elem="true" :right="true">
            <button type="button" class="btn btn-secondary">
              <font-awesome-icon icon="calendar-alt" />
            </button>
          </VueCtkDateTimePicker>
        </b-input-group-append>
      </b-input-group>
      <span class="text-danger" v-if="fieldErrors.simple_date_obs_min">{{fieldErrors.simple_date_obs_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-input-group>
        <b-form-input v-model="fields.simple_date_obs_max" placeholder="yyyy-MM-dd"></b-form-input>
        <b-input-group-append>
          <VueCtkDateTimePicker v-model="fields.simple_date_obs_max" format="YYYY-MM-DD" :no-label="true" :only-date="true" :no-value-to-custom-elem="true" :right="true">
            <button type="button" class="btn btn-secondary">
              <font-awesome-icon icon="calendar-alt" />
            </button>
          </VueCtkDateTimePicker>
        </b-input-group-append>
      </b-input-group>
      <span class="text-danger" v-if="fieldErrors.simple_date_obs_max">{{fieldErrors.simple_date_obs_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.simple_program_sel" :disabled="toggleStatus" class="mt-1">Project id</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.simple_program"></b-form-input>
    </div>
  </div>
</div>
</template>

<script>
import NameResolver from './RadioNameResolver.vue';
import ToggleAllButton from './ToggleAllButton.vue';
import {
  mapState
} from 'vuex';

export default {
  name: 'SimpleSearch',
  components: {
    NameResolver,
    ToggleAllButton
  },
  computed: mapState({
    fields: state => state.searchForm.fields,
    fieldErrors: state => state.searchForm.fieldErrors,
    toggleStatus: state => state.searchForm.toggleStatus['simple']
  })
}
</script>
